"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRowIndexToBeRemoved = exports.seComponentToBeRemoved = exports.onHideSavePrompt = exports.onShowSavePrompt = exports.setSelectedSystemName = exports.deleteAssociationError = exports.deleteAssociationSuccess = exports.deleteAssociation = exports.closeDeleteAssociationModal = exports.openDeleteAssociationModal = exports.associateSystemComponentsError = exports.associateSystemComponentsSuccess = exports.associateSystemComponents = exports.resetSystemComponentsList = exports.listSystemComponentsError = exports.listSystemComponentsSuccess = exports.listSystemComponents = exports.systemComponentsSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    systemComponents: [],
    selectedSystemName: "",
    areSystemComponentsLoading: false,
    hasErrorLoadingSystemComponents: false,
    isAssociatingComponents: false,
    hasErrorAssociatingComponents: false,
    associateComponentsSuccess: false,
    isDeletingAssociation: false,
    deleteAssociationSuccess: false,
    deleteAssociationError: false,
    systemComponentsToast: { isOpen: false, message: "", status: undefined },
    isDeleteAssociationModalOpen: false,
    isSavePromptVisible: false,
    componentToBeRemoved: null,
    rowIndexToBeUnlinked: 0
};
exports.systemComponentsSlice = (0, toolkit_1.createSlice)({
    name: "systemComponents",
    initialState,
    reducers: {
        listSystemComponents: (state) => {
            state.areSystemComponentsLoading = true;
        },
        listSystemComponentsSuccess: (state, action) => {
            state.areSystemComponentsLoading = false;
            state.hasErrorLoadingSystemComponents = false;
            state.systemComponents = action.payload;
        },
        listSystemComponentsError: (state) => {
            state.areSystemComponentsLoading = false;
            state.hasErrorLoadingSystemComponents = true;
        },
        resetSystemComponentsList: (state) => {
            state.systemComponents = [];
        },
        associateSystemComponents: (state) => {
            state.isAssociatingComponents = true;
            state.hasErrorAssociatingComponents = false;
            state.associateComponentsSuccess = false;
        },
        associateSystemComponentsSuccess: (state) => {
            state.isAssociatingComponents = true;
            state.hasErrorAssociatingComponents = false;
            state.associateComponentsSuccess = true;
        },
        associateSystemComponentsError: (state) => {
            state.isAssociatingComponents = false;
            state.hasErrorAssociatingComponents = true;
            state.associateComponentsSuccess = false;
        },
        openProductsToast: (state, action) => {
            state.systemComponentsToast.status = action.payload.status;
            state.systemComponentsToast.message = action.payload.message;
            state.systemComponentsToast.isOpen = true;
        },
        closeProductToast: (state) => {
            state.systemComponentsToast.isOpen = false;
            state.systemComponentsToast.status = undefined;
            state.systemComponentsToast.message = "";
        },
        deleteAssociation: (state) => {
            state.isDeletingAssociation = true;
            state.deleteAssociationError = false;
            state.deleteAssociationSuccess = false;
        },
        deleteAssociationSuccess: (state) => {
            state.isDeletingAssociation = false;
            state.deleteAssociationError = false;
            state.deleteAssociationSuccess = false;
        },
        deleteAssociationError: (state) => {
            state.isDeletingAssociation = false;
            state.deleteAssociationError = true;
            state.deleteAssociationSuccess = false;
        },
        openDeleteAssociationModal: (state) => {
            state.isDeleteAssociationModalOpen = true;
        },
        closeDeleteAssociationModal: (state) => {
            state.isDeleteAssociationModalOpen = false;
        },
        setSelectedSystemName: (state, action) => {
            state.selectedSystemName = action.payload;
        },
        onShowSavePrompt: (state) => {
            state.isSavePromptVisible = true;
        },
        onHideSavePrompt: (state) => {
            state.isSavePromptVisible = false;
        },
        seComponentToBeRemoved: (state, action) => {
            state.componentToBeRemoved = action.payload;
        },
        setRowIndexToBeRemoved: (state, action) => {
            state.rowIndexToBeUnlinked = action.payload;
        },
    },
});
_a = exports.systemComponentsSlice.actions, exports.listSystemComponents = _a.listSystemComponents, exports.listSystemComponentsSuccess = _a.listSystemComponentsSuccess, exports.listSystemComponentsError = _a.listSystemComponentsError, exports.resetSystemComponentsList = _a.resetSystemComponentsList, exports.associateSystemComponents = _a.associateSystemComponents, exports.associateSystemComponentsSuccess = _a.associateSystemComponentsSuccess, exports.associateSystemComponentsError = _a.associateSystemComponentsError, exports.openDeleteAssociationModal = _a.openDeleteAssociationModal, exports.closeDeleteAssociationModal = _a.closeDeleteAssociationModal, exports.deleteAssociation = _a.deleteAssociation, exports.deleteAssociationSuccess = _a.deleteAssociationSuccess, exports.deleteAssociationError = _a.deleteAssociationError, exports.setSelectedSystemName = _a.setSelectedSystemName, exports.onShowSavePrompt = _a.onShowSavePrompt, exports.onHideSavePrompt = _a.onHideSavePrompt, exports.seComponentToBeRemoved = _a.seComponentToBeRemoved, exports.setRowIndexToBeRemoved = _a.setRowIndexToBeRemoved;
exports.default = exports.systemComponentsSlice.reducer;
